import { useEffect, useRef } from "react";

const VIDEO_MP4_LOCATION = "/tm_loop_v3.mp4";
const VIDEO_WEBM_LOCATION = "/tm_loop_v3.webm";

type BackgroundVideoProps = { className?: string; shouldPauseVideo: boolean };

export const BackgroundVideo = ({ shouldPauseVideo, className }: BackgroundVideoProps) => {
  const backgroundVideoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    // Slow the loop video down slightly
    if (backgroundVideoRef.current) {
      backgroundVideoRef.current.playbackRate = 0.8;
    }
  }, []);

  useEffect(() => {
    if (!backgroundVideoRef.current) return;

    if (backgroundVideoRef.current.paused) {
      void backgroundVideoRef.current.play();
    } else {
      backgroundVideoRef.current.pause();
    }
  }, [shouldPauseVideo]);

  return (
    <video className={className} ref={backgroundVideoRef} autoPlay loop muted playsInline>
      <source src={VIDEO_WEBM_LOCATION} type="video/webm" />
      <source src={VIDEO_MP4_LOCATION} type="video/mp4" />
    </video>
  );
};
